import { createFileRoute } from "@tanstack/react-router"
import { ReverAuthModal } from "modules/settings/components/integrations/rever/ReverAuthModal"

export const Route = createFileRoute("/_base/_auth/settings/integrations/rever/connect")({
  component: ReverAuthModal,
})
